/* eslint-disable max-len */
import { combineReducers } from 'redux';
import * as sessionReducere from './sessionReducer';
import * as appReducers from './appReducer';
import * as appAreasReducers from './appAreasReducers';
import * as appearanceGlobalAssetsReducer from './appearanceGlobalAssetsReducer';
import * as appearanceSkinsReducer from './appearanceSkinsReducer';
import * as appearanceSkinReducer from './appearanceSkinReducer';
import * as videoContentReducer from './videoContentReducer';
import * as videoContentCategoriesReducer from './videoContentCategoriesReducer';
import * as videoContentMainPanelReducer from './videoContentMainPanelReducer';
import * as videoContentMainPanelExtraButtonsReducer from './videoContentMainPanelExtraButtonsReducer';
import * as videoContentVideosReducer from './videoContentVideosReducers';
import { downloadableFileReducer } from './downloadableFileReducer';
import { backgroundFileReducer } from './backgroundFileReducer';
import { videoContentCategoriesPanelReducer } from './videoContentCategoriesPanelReducer';
import { videoContentSidePanelsReducer } from './videoContentSidePanelsReducer';
import { vodReducer } from './vodReducer';
import { vodOptimizationSettingsReducer } from './vodOptimizationSettingsReducer';
import { vodOutputsReducer } from './vodOutputsReducer';
import { originOutputsReducer } from './originOutputsReducer';
import { errorReducer } from './errorReducer';
import { listTableReducer } from './listTableReducer';
import { formReducer } from './formReducer';
import { camerasPresentationReducer } from './camerasPresentationReducer';
import { composeExperienceReducer } from './composeExperienceReducer';
import { composeExperienceUrlsReducer } from './composeExperienceUrlsReducer';
import { additionalMetadataReducer } from './additionalMetadataReducer';
import { mainHubConfigReducer } from './mainHubConfigReducer';
import * as canvasContentInfoReducer from './canvasContentInfoReducer';
import * as mainMenuReducer from './mainMenuReducer';

export const storeStructure = {
  Session: 'session',
  APPS: 'apps',
  AppAreas: 'appAreas',
  AppearanceGlobalAssets: 'appearanceGlobalAssets',
  AppearanceSkins: 'appearanceSkins',
  AppearanceSkin: 'appearanceSkin',
  VideoContent: 'videoContent',
  VideoContentCategoriesPanel: 'videoContentCategoriesPanel',
  VideoContentCategories: 'videoContentCategories',
  VideoContentMainPanel: 'videoContentMainPanel',
  VideoContentMainPanelExtraButtons: 'videoContentMainPanelExtraButtons',
  VideoContentSidePanels: 'videoContentSidePanels',
  VideoContentVideos: 'videoContentVideos',
  DownloadableFiles: 'downloadableFiles',
  BackgroundFiles: 'backgroundFiles',
  VoD: 'vods',
  VoDOptimizationSettings: 'vodOptimizationSettings',
  VoDOutputs: 'vodOutputs',
  OriginOutputs: 'originOutputs',
  S3ExternalResources: 's3externalResources',
  Errors: 'errors',
  ListTable: 'listTable',
  FormData: 'formData',
  AdditionalMetadata: 'additionalMetadata',
  ComposeExperience: 'composeExperience',
  ComposeExperienceUrls: 'composeExperienceUrls',
  CamerasPresentation: 'camerasPresentation',
  mainHubConfigs: 'mainHubConfigs',
  CanvasContentInfo :'canvasContentInfo',
  MainMenu: 'mainMenu',
};

const storeNodes = {};

storeNodes[storeStructure.Session] = sessionReducere.sessionReducer;
storeNodes[storeStructure.APPS] = appReducers.appsReducer;
storeNodes[storeStructure.AppAreas] = appAreasReducers.appAreasReducer;
storeNodes[storeStructure.AppearanceGlobalAssets] = appearanceGlobalAssetsReducer.appearanceGlobalAssetsReducer;
storeNodes[storeStructure.AppearanceSkins] = appearanceSkinsReducer.appearanceSkinsReducer;
storeNodes[storeStructure.AppearanceSkin] = appearanceSkinReducer.appearanceSkinReducer;
storeNodes[storeStructure.VideoContent] = videoContentReducer.videoContentReducer;
storeNodes[storeStructure.VideoContentCategoriesPanel] = videoContentCategoriesPanelReducer;
storeNodes[storeStructure.VideoContentCategories] = videoContentCategoriesReducer.videoContentCategoriesReducer;
storeNodes[storeStructure.VideoContentMainPanel] = videoContentMainPanelReducer.videoContentMainPanelReducer;
storeNodes[storeStructure.VideoContentMainPanelExtraButtons] = videoContentMainPanelExtraButtonsReducer.videoContentMainPanelExtraButtonsReducer;
storeNodes[storeStructure.VideoContentSidePanels] = videoContentSidePanelsReducer;
storeNodes[storeStructure.VideoContentVideos] = videoContentVideosReducer.videoContentVideosReducer;
storeNodes[storeStructure.DownloadableFiles] = downloadableFileReducer;
storeNodes[storeStructure.BackgroundFiles] = backgroundFileReducer;
storeNodes[storeStructure.VoD] = vodReducer;
storeNodes[storeStructure.VoDOptimizationSettings] = vodOptimizationSettingsReducer;
storeNodes[storeStructure.VoDOutputs] = vodOutputsReducer;
storeNodes[storeStructure.OriginOutputs] = originOutputsReducer;
storeNodes[storeStructure.Errors] = errorReducer;
storeNodes[storeStructure.ListTable] = listTableReducer;
storeNodes[storeStructure.FormData] = formReducer;
storeNodes[storeStructure.ComposeExperience] = composeExperienceReducer;
storeNodes[storeStructure.ComposeExperienceUrls] = composeExperienceUrlsReducer;
storeNodes[storeStructure.CamerasPresentation] = camerasPresentationReducer;
storeNodes[storeStructure.AdditionalMetadata] = additionalMetadataReducer;
storeNodes[storeStructure.mainHubConfigs] = mainHubConfigReducer;
storeNodes[storeStructure.CanvasContentInfo] = canvasContentInfoReducer.canvasContentInfoReducer;
storeNodes[storeStructure.MainMenu] = mainMenuReducer.mainMenuReducer;

export default combineReducers(storeNodes);